export const PAGINATION_LOCALE_ZHCHT = {
    message: 'å± <b>{1}</b> æ¢ ',
    totalinfo: {
        firstText: 'å±',
        lastText: 'æ¢'
    },
    pagelist: {
        firstText: 'æ¯é ',
        lastText: 'æ¢'
    },
    previous: 'ä¸ä¸é ',
    next: 'ä¸ä¸é ',
    goto: {
        prefix: 'è·³è³',
        suffix: 'é '
    }
};
